import React from "react";
import Container from "ui/Container/Container";
import YandexWidgetReviews from "common/YandexWidgetReviews/YandexWidgetReviews";
import Copyright from "../Copyright/Copyright";
import Payments from "../Payments/Payments";
import styles from "./Bottom.module.scss";

const Bottom: React.FC = () => (
  <div className={styles.footer500Bottom}>
    <Container>
      <Copyright />
      <Payments />
      <div className={styles.footer500BottomUntilLaptop}>
        <YandexWidgetReviews />
      </div>
    </Container>
  </div>
);

export default Bottom;
